/** Consume an app-authenticated response. This module never chooses a URL, user, or credential. */
export async function readOutputDownload(response, fallbackFilename = 'attachment', maxBytes = 30 * 1024 * 1024) {
    if (!Number.isSafeInteger(maxBytes) || maxBytes <= 0)
        throw new Error('invalid_output_limit');
    if (!response.ok)
        throw new Error('output_download_failed');
    const disposition = response.headers.get('content-disposition') || '';
    const encoded = /filename\*=UTF-8''([^;]+)/i.exec(disposition)?.[1];
    let filename;
    try {
        filename = encoded ? decodeURIComponent(encoded) : /filename="([^"]+)"/.exec(disposition)?.[1] || fallbackFilename;
    }
    catch {
        throw new Error('invalid_output_filename');
    }
    if (!filename || /[\/\\\x00-\x1f\x7f]/.test(filename))
        throw new Error('invalid_output_filename');
    if (!response.body)
        throw new Error('empty_output');
    const reader = response.body.getReader();
    const chunks = [];
    let size = 0;
    try {
        while (true) {
            const { done, value } = await reader.read();
            if (done)
                break;
            size += value.byteLength;
            if (size > maxBytes)
                throw new Error('output_too_large');
            chunks.push(new Uint8Array(value));
        }
    }
    catch (error) {
        await reader.cancel().catch(() => undefined);
        throw error;
    }
    finally {
        reader.releaseLock();
    }
    if (!size)
        throw new Error('empty_output');
    return { blob: new Blob(chunks, { type: response.headers.get('content-type') || 'application/octet-stream' }), filename };
}
